import { Fragment, useEffect } from "react";
import MedilogLogo from "./components/MedilogLogo";
import MagicWareFooter from "../../shared/components/MagicWareFooter";
import LocSwitcher from "@profilog/misc/lang/LocSwitcher";
import supportedLangs from "../../localization/SupportedLangs.json";
import MedilogStaticLinks from "./components/MedilogStaticLinks";
import { Link, Outlet, useLocation } from "react-router-dom";
import addNavBarToggler from "@profilog/misc/utils/NavBarToggler";
import "./MedilogPublicLayout.scss";

export default function MedilogPublicLayout() {
    useEffect(() => {
        addNavBarToggler();
    }, []);

    const location = useLocation();
    const isHome = location.pathname === "/";

    return (
        <Fragment>
            <header className={isHome ? "" : "bg-nonhome"}>
                <section className="header--home container">
                    <nav className="navbar navbar-expand-sm navbar-dark">
                        <Link className="navbar-brand" to="/">
                            <MedilogLogo />
                        </Link>
                        <button
                            className="navbar-toggler d-lg-none"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapsibleNavId"
                            aria-controls="collapsibleNavId"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <i className="fas fa-bars text-white"></i>
                            <i className="fas fa-times text-white"></i>
                        </button>
                        <div className="collapse navbar-collapse" id="collapsibleNavId">
                            <ul className="navbar-nav ml-auto mt-2 mt-lg-0">
                                <MedilogStaticLinks />
                            </ul>
                        </div>

                        <LocSwitcher supportedLangs={supportedLangs} themeColor="menuBar" />
                    </nav>
                </section>
            </header>

            <Outlet />

            <MagicWareFooter />
        </Fragment>
    );
}
